import { render } from "./ShipmentList_menu_delete.vue?vue&type=template&id=74f60372"
import script from "./ShipmentList_menu_delete.vue?vue&type=script&lang=js"
export * from "./ShipmentList_menu_delete.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__